var $22e724fcc24f71d2$exports = {};
$22e724fcc24f71d2$exports = {
    "loading": `\u{417}\u{430}\u{432}\u{430}\u{43D}\u{442}\u{430}\u{436}\u{435}\u{43D}\u{43D}\u{44F}\u{2026}`,
    "placeholder": `\u{412}\u{438}\u{431}\u{440}\u{430}\u{442}\u{438}\u{2026}`
};


export {$22e724fcc24f71d2$exports as default};
//# sourceMappingURL=uk-UA.mjs.map
